<template>
  <div class="card-box">
    <h4 class="header-title m-t-0 m-b-20">
      Documents
    </h4>

    <div class="file-list">
      <el-tooltip class="item" content="Envoyer un document">
        <el-upload
          style="padding: 0; border: 0;"
          class="file-list-item"
          drag
          :action="uploadEndpointUrl"
          :show-file-list="false"
          :on-success="handleUploadSuccess"
          :on-progress="handleUploadProgress"
          :before-upload="beforeUpload">
          <i class="el-icon-plus" style="margin-top: 25%;"></i>
        </el-upload>
      </el-tooltip>
      <el-tooltip
        class="item"
        :content="getStatus(document).text"
        v-for="document in orderedDocuments"
        :key="document.id">
        <div
          @mouseover="handleDocumentHover(document)"
          @mouseout="clearDocumentHover"
          :class="['file-list-item', (isLinkedDocumentHovered(document) ? 'file-list-item-hovered' : '')]"
          style="position: relative;">
          <span v-if="document.type === 'uploads'" style="position: absolute; right: 2px; top: 0;" @click="deleteDocument(document)">
              <i class="fa fa-times text-danger" style="font-size: 22px;"></i>
            </span>
          <div @click="downloadDocument(document)">
            <source-app
              v-if="document.source_name"
              style="position: absolute; left: 2px; top: 0;"
              :name="document.source_name"
              size="tiny">
            </source-app>
            <div v-else style="position: absolute; left: 2px; top: 0;">
              <span class="label label-dark">Envoyé</span>
            </div>

            <div style="position: absolute; left: 55%; top: 48px; margin: 2px;">
              <i style="font-size: 18px;"
                 :class="['fa', getStatus(document).icon, 'text-' + getStatus(document).color]"></i>
            </div>
            <i v-if="document.type === 'invoices'" class="fas fa-file-invoice-dollar"></i>
            <i v-if="document.type === 'contracts'" class="fas fa-file-signature"></i>
            <i v-if="document.type === 'estimates'" class="fas fa-file-invoice"></i>
            <i v-if="document.type === 'uploads'" class="fas fa-file-upload"></i>
            <div v-if="document.type === 'invoices'" class="name"><strong>Facture</strong>
              ({{ new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(document.amount_total) }})
            </div>
            <div v-else-if="document.type === 'contracts'" class="name"><strong>Contrat</strong></div>
            <div v-else-if="document.type === 'estimates'" class="name"><strong>BDC</strong>
              ({{ new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(document.amount_total) }})
            </div>
            <div v-else-if="document.type === 'uploads'" class="name"><strong>{{ document.file_name }}</strong></div>
            <div class="date">{{ document.created_at | moment('DD/MM/YYYY') }}</div>
          </div>
        </div>
      </el-tooltip>
    </div>

    <div class="m-t-20 row">
      <div class="col-md-2">
        <el-tooltip content="Filtrer les sociétés">
          <el-select v-model="displayType.selected" size="small" placeholder="Société :">
            <el-option
              v-for="item in displayType.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-tooltip>
      </div>

      <div class="col-md-2">
        <el-checkbox v-model="hideInvoices">
          <span style="font-size: 12px;">Cacher les factures</span>
        </el-checkbox>
      </div>
    </div>

    <el-dialog title="Envoi d'un document" :close-on-click-modal="false" :visible.sync="dialog.visible" size="tiny">
      <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
        <el-row :gutter="20" class="m-b-20">
          <el-col :span="24">
            <el-progress :text-inside="true" :stroke-width="18" :status="upload.progression === 100 ? 'success' : ''" :percentage="upload.progression"></el-progress>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="uploadable_type" label="Type du document">
              <el-select v-model="form.uploadable_type" placeholder="Select">
                <el-option label="Autre" value=""></el-option>
                <el-option label="Bon de commande" value="App\Estimate"></el-option>
                <el-option label="Contrat" value="App\Contract"></el-option>
                <el-option label="Facture" value="App\Invoice"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="uploadable_id" v-if="form.uploadable_type !== ''" label="Document original lié">
              <el-select v-model="form.uploadable_id" class="form-control" placeholder="Selectionnez un document original">
                <el-option
                  v-if="form.uploadable_type === 'App\\Invoice'"
                  v-for="invoice in [...relations.invoices].sort((a, b) => moment(a.created_at).isBefore(b.created_at))"
                  :key="'invoice_'+  invoice.id"
                  :value="invoice.id"
                  :label="'Facture (' + new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(invoice.amount_total) + ') du ' + moment(invoice.created_at).format('DD/MM/YYYY')">
                </el-option>
                <el-option
                  v-if="form.uploadable_type === 'App\\Contract'"
                  v-for="contract in [...relations.contracts].sort((a, b) => moment(a.created_at).isBefore(b.created_at))"
                  :key="'contract_'+  contract.id"
                  :value="contract.id"
                  :label="'Contrat du ' + moment(contract.created_at).format('DD/MM/YYYY')">
                </el-option>
                <el-option
                  v-if="form.uploadable_type === 'App\\Estimate'"
                  v-for="estimate in [...relations.estimates].sort((a, b) => moment(a.created_at).isBefore(b.created_at))"
                  :key="'estimate_'+  estimate.id"
                  :value="estimate.id"
                  :label="'BDC (' + new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(estimate.amount_total) + ') du ' + moment(estimate.created_at).format('DD/MM/YYYY')">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="file_name" label="Nom du fichier">
          <el-input placeholder="Saisissez le nom du fichier" v-model="form.file_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">Cancel</el-button>
        <span v-if="form.file_url === null">
          <el-button type="primary" :disabled="true">Envoi en cours ...</el-button>
        </span>
        <span v-else>
          <el-button type="primary" @click="submit()">Créer le document</el-button>
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<style>
  .file-list {
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 10px;
  }

  .file-list-item {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    padding-top: 15px;
    padding-bottom: 10px;
    text-align: center;
    margin-right: 10px;
    width: 140px;
    border-radius: 6px;
    wrap-option: always;
  }

  .file-list-item:hover {
    border: 1px dashed #64b0f2;
    cursor: pointer;
  }

  .file-list-item-hovered {
    border: 2px dashed #1bb99a;
    padding-top: 14px;
    padding-bottom: 9px;
  }

  .file-list-item:hover i {
    color: #64b0f2;
  }

  .file-list-item i {
    font-size: 3em;
    color: #8c939d;
    margin-bottom: 15px;
  }

  .file-list-item .name {
  }

  .file-list-item .date {
    color: #818a91;
  }

  .el-upload-dragger {
    width: 140px !important;
    height: 109px !important;
  }
</style>

<script>
  import SourceApp from '@db2b/keystone/components/Entities/SourceApp.vue'

  import moment from 'moment'
  import { events } from '@/services/event-bus.js'

  export default {
    components: {SourceApp},
    name: 'customer-documents',
    props: ['customer', 'relations'],
    data () {
      return {
        fields: {
          validation: {
            file_name: [
              { required: true, message: 'Vous devez saisir un nom de fichier', trigger: 'change' }
            ]
          }
        },
        form: {
          uploadable_type: '',
          uploadable_id: null,
          user_id: this.$store.getters['users/current'].id,
          company_id: 1,
          customer_id: this.customer.id,
          file_name: '',
          file_url: null
        },
        upload: {
          progression: 0
        },
        dialog: {
          visible: false
        },
        hover: {
          uploadable_type: null,
          uploadable_id: null
        },
        hideInvoices: true,
        displayType: {
          options: [{
            value: 0,
            label: 'Tout afficher'
          }, {
            value: 1,
            label: 'Devis B2B'
          }, {
            value: 2,
            label: 'Algiciel'
          }],
          selected: 0
        }
      }
    },
    computed: {
      uploadEndpointUrl () {
        return this.$nexus.url('document2', 'file') + '?nexus_token=' + this.$nexus.getToken()
      },
      orderedDocuments () {
        let documents = []
        let resources = ['contracts', 'invoices', 'estimates', 'uploads']

        for (let i = 0; i < 4; i++) {
          if (this.hideInvoices && i === 1) {
            continue
          }

          for (let y = 0; y < this.relations[resources[i]].length; y++) {
            if (this.displayType.selected === 0 || this.relations[resources[i]][y].company_id === this.displayType.selected) {
              this.relations[resources[i]][y].type = resources[i]
              documents.push(this.relations[resources[i]][y])
            }
          }
        }

        return documents.sort((a, b) => moment(a.created_at).isBefore(b.created_at))
      }
    },
    watch: {
      form: {
        handler: function (form) {
          if (form.uploadable_type && form.uploadable_id) {
            if (form.uploadable_type === 'App\\Invoice') {
              this.form.file_name = 'Facture ' + this.relations.invoices.find(invoice => invoice.id === form.uploadable_id).number
            } else if (form.uploadable_type === 'App\\Estimate') {
              this.form.file_name = 'BDC ' + this.relations.estimates.find(invoice => invoice.id === form.uploadable_id).number
            } else if (form.uploadable_type === 'App\\Contract') {
              this.form.file_name = 'Contrat ' + this.relations.contracts.find(invoice => invoice.id === form.uploadable_id).number
            }
          } else if (form.uploadable_type) {
            if (form.uploadable_type === 'App\\Invoice') {
              this.form.file_name = 'Facture'
            } else if (form.uploadable_type === 'App\\Estimate') {
              this.form.file_name = 'BDC'
            } else if (form.uploadable_type === 'App\\Contract') {
              this.form.file_name = 'Contrat'
            }
          }
        },
        deep: true
      }
    },
    methods: {
      downloadDocument (document) {
        window.location = document.file_url
      },
      deleteDocument (document) {
        let self = this

        this.$confirm('Supprimer ce document ?', 'Warning', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          let link = window.document.createElement('a')
          link.href = document.file_url

          Promise.all([
            self.$nexus.delete('document2', 'uploads/' + document.id),
            self.$nexus.delete('document2', link.pathname)
          ]).then(response => {
            events.emit('app/ui/customer/reload')
          })
        }).catch(() => {})
      },
      getStatus (document) {
        let type = document.type.slice(0, -1)
        if (type === 'estimate') {
          return this.$model.estimate.getStatus(document)
        } else if (type === 'invoice') {
          return this.$model.invoice.getStatus(document)
        } else if (type === 'contract') {
          return this.$model.invoice.getStatus(document)
        } else if (type === 'upload') {
          let text = 'Document envoyé'

          if (document.uploadable_id) {
            if (document.uploadable_type === 'App\\Invoice') {
              text = 'Lié à la facture ' + document.uploadable_id
            } else if (document.uploadable_type === 'App\\Estimate') {
              text = 'Lié au BDC ' + document.uploadable_id
            } else if (document.uploadable_type === 'App\\Contract') {
              text = 'Lié au contrat ' + document.uploadable_id
            }
          }

          return {
            text: text,
            color: 'success',
            icon: 'fa-check'
          }
        } else {
          return null
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            self.$model.upload.api().create(this.form).then(() => {
              Object.assign(self.$data, self.$options.data.apply(self))
              events.emit('app/ui/customer/reload')
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      },
      isLinkedDocumentHovered (document) {
        if (document.id !== this.hover.uploadable_id) {
          return false
        }
        if (document.type === 'invoices' && this.hover.uploadable_type === 'App\\Invoice') {
          return true
        } else if (document.type === 'estimates' && this.hover.uploadable_type === 'App\\Estimate') {
          return true
        } else if (document.type === 'contracts' && this.hover.uploadable_type === 'App\\Contract') {
          return true
        }

        return false
      },
      clearDocumentHover () {
        this.hover.uploadable_type = null
        this.hover.uploadable_id = null
      },
      handleDocumentHover (document) {
        if (document.type === 'uploads') {
          this.hover.uploadable_type = document.uploadable_type
          this.hover.uploadable_id = document.uploadable_id
        }
      },
      handleUploadSuccess (res, file) {
        this.form.file_url = res.url
      },
      handleUploadProgress (event, file, fileList) {
        this.upload.progression = Math.round(event.percent)
      },
      beforeUpload (file) {
        const isPDF = file.type === 'application/pdf'
        const isWord = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(file.type)

        const isLt32M = file.size / 1024 / 1024 < 32

        if (!isPDF && !isWord) {
          this.$message.error('Le document doit être au format PDF ou Word !')
        }
        if (!isLt32M) {
          this.$message.error('La taille du document ne peut dépasser 32 Mo !')
        }

        if ((isPDF || isWord) && isLt32M) {
          this.dialog.visible = true
          return true
        } else {
          return false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerDocuments.vue?a9ac4ad6